export default __webpack_public_path__ + "static/media/Astronaut.e3c88a02.png";